module.exports = __webpack_public_path__ + "54453c51151c29453f946c1713fe35ae.svg";